import { Lang } from "@/i18n/settings";
import { getTokenFromFE } from "../token";
import { feApi } from "@/app/api/utils/api";
import { ApiResponse } from "@/types";
import { NomineesBeResponse } from "./nominees.server";

interface GetNomineesParams {
  lang: Lang;
  pageNo?: number;
  pageSize?: number;
  year?: string;
  category?: string;
  type?: string;
  subCategory?: string;
}

export async function getNominees({
  lang,
  pageNo,
  pageSize,
  year,
  category,
  subCategory,
}: GetNomineesParams) {
  try {
    const token = await getTokenFromFE();

    const queryParams = new URLSearchParams();

    if (pageNo) queryParams.append("pageNo", pageNo.toString());
    if (pageSize) queryParams.append("pageSize", pageSize.toString());
    if (year) queryParams.append("year", year);
    if (category) queryParams.append("category", category);
    if (subCategory) queryParams.append("subcategory", subCategory);

    const res = await feApi
      .auth(`Bearer ${token}`)
      .options({ next: { revalidate: 60 } })
      .url("/v1")
      .get(`/${lang}/nominees?${queryParams.toString()}`);
    return res as ApiResponse<NomineesBeResponse["data"]>;
  } catch (error) {
    console.error(error);

    return null;
  }
}
